import { Component, Input } from '@angular/core';

export type StatusType = 'success' | 'warning' | 'error' | 'info' | 'default';

@Component({
  selector: 'marina-status-badge',
  standalone: false,
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.scss'],
})
export class StatusBadgeComponent {
  @Input() status: StatusType = 'default';
  @Input() label: string = '';
  @Input() icon?: string;

  getStatusClass(): string {
    return `status-${this.status}`;
  }

  getStatusColor(): string {
    const colors: Record<StatusType, string> = {
      success: 'primary',
      warning: 'accent',
      error: 'warn',
      info: 'primary',
      default: '',
    };
    return colors[this.status] || '';
  }
}

